import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LegalNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LocaleLink.tsx");
